import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../core/authentication.service';
import { ResponseDTO } from '../models/response-dto';
import { AppSettings } from '../shared/App-Settings';

const apiUrl = AppSettings.API_BASE_URL + "api/";

@Injectable({
  providedIn: 'root'
})
export class UserAccessService {

  constructor(private httpClient: HttpClient, private auth: AuthenticationService) { }

  getUserPrivilege(): Observable<ResponseDTO> {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };
    let url = `${apiUrl}userPrivilegeList`;

    return this.httpClient.get<any>(url, httpOptions);
  }
}
